/**
 * Retorna o elemento se existir e estiver visível (inclui ancestrais ocultos via offsetParent).
 * @param {string} selector
 * @returns {Element|null}
 */
export default function elementoVisivel(selector) {
  const el = document.querySelector(selector);
  if (!el) return null;
  const style = window.getComputedStyle(el);
  if (style.display === 'none' || style.visibility === 'hidden') return null;
  if (el.offsetParent === null && style.position !== 'fixed') return null;
  return el;
}
